<template>
	<div class="picture_and_video_box">
		<div v-if="fileList && fileList.SlideTotal > 0" class="media-carousel" @mouseenter="stopAutoplay()"  @mouseleave="startAutoplay()">
		
			<!-- :ref="'swiper' + fileList ? fileList.post_id : 1" -->
			<swiper 
				:ref="swiper_post_id"
				class="swiper swiperBox" 
				:options="swiperOption" 
				@mouseenter="stopAutoplay" 
				@mouseleave="startAutoplay"
				@slideChangeTransitionEnd="change"
			>	
				<!-- 总数和当前数 -->
				<div class="quantityBox" v-if="fileList && fileList.SlideTotal > 1">
					<div class="quantity">{{ fileList.currentSlideIndex ? fileList.currentSlideIndex : 1 }}</div>
					<div class="quantity">/</div>
					<div class="quantity">{{ fileList.SlideTotal }}</div>
				</div>
				<!-- 图片轮播 -->
				<swiper-slide
					v-if="fileList.pics && fileList.pics.length > 0"
					v-for="(img_item, img_index) in fileList.pics"
					:key="'img-' + img_index"
					:class="img_item.video ? 'slideLiveBox' : ''"
				>
					<div v-if="img_item.video" class="LiveBtn" :class="!img_item.LivePlayState ? 'pointer' : 'no-drop noBtn '" @click.stop="LivePlay(img_item)">{{ $t('SwiperArr.Live') }}</div>
					<img v-if="!img_item.LivePlayState" :src="img_item.url" class="media-image" :alt="'The TOZO community post contains a picture of ' + fileList.content"/>
					<video v-else :ref="liveVideo_post_id" autoplay muted class="Live-video" @ended="stopLivePlay(img_item)">
						<source :src="img_item.video" type="video/mp4">
						<!-- <source src="https://s3-us-tozo-test-wr.tozostore.com/Admin/app30/video/202501070712262626_1736233946qBnvkNdkM6VRX61g.mp4" type="video/mp4"> -->
					</video>
				</swiper-slide>

				<!-- 视频轮播 -->
				<swiper-slide
					v-if="fileList.videos && fileList.videos.length > 0"
					v-for="(video_item, video_index) in fileList.videos"
					:key="'video-' + video_index"
				>
					<video :src="video_item" controls class="media-video" :poster="fileList.video_cover">
						<source :src="video_item" type="video/mp4">
					</video>
				</swiper-slide>
				<!-- Pagination -->
				<!-- <div class="swiper-pagination"></div> -->
				<div v-show="fileList && fileList.SlideTotal > 1" class="swiper-pagination" @click.stop></div>
			</swiper>
		</div>
	</div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'

let vm = null;

export default {
  name: 'media-content',
  components: { Swiper, SwiperSlide },
  props: {
    fileList: {
      type: Object,
        default: () => ({
            SlideTotal: 0,
            pics: [
					{LivePlayState: false}
				],
            videos: [],
            currentSlideIndex: 1
        })
    },
    swiperList: {
      type: Array,
      default() {
        return [{}];
      },
    },
  },
	computed: {
		swiper() {
			return this.$refs[`swiper${this.fileList.post_id}`].$swiper
		},
		liveVideo() {
			return this.$refs[`liveVideo${this.fileList.post_id}`]
		}
	},
	
  data() {
		return {
        swiper_post_id: `swiper${this.fileList.post_id}`,
        liveVideo_post_id: `liveVideo${this.fileList.post_id}`,
        swiperOption: {
            slidesPerView: 1,
            spaceBetween: 30,
            loop: this.fileList && this.fileList.SlideTotal > 1,
            touchMoveStopPropagation: true,
            autoplay: this.fileList && this.fileList.SlideTotal > 1? {
               delay: 5000,
               disableOnInteraction: false
            } : false,
            effect: 'fade',
            preventClicks: true,
            fadeEffect: { crossFade: true },
            pagination: {
               el: '.swiper-pagination',
               type: 'bullets',
               clickable: true
            },
            navigation: {
               nextEl: '.swiper-button-next',
               prevEl: '.swiper-button-prev'
            },
            rtl: true,
				on: {
				  click:function(clickedIndex){},
				},
				realIndex: 0,
				indexOfPlayingVideo: NaN,
				pauseVideoCb: function() {}
			}
		};
  },

	created() {
		vm = this;
	},
	
	mounted() {
		// 然后获取Swiper实例相关操作
		this.$nextTick(() => {
			this.change()
		});
	},

	methods: {
		handleClickSlide(clickedIndex){
			this.$nextTick(() => {
				var swiper = this.swiper;
				this.realIndex = swiper.activeIndex = clickedIndex
			});
		},
		
		change() {
			this.realIndex = this.swiper.realIndex
			this.$set(this.fileList, 'currentSlideIndex', this.realIndex+1); //更新序号
			if (this.swiper.realIndex !== this.indexOfPlayingVideo) {
			// this.pauseVideoCb()
			}
		},
		
		// 播放
		handlePlay(pauseVideoCb, slideIndex) {
			this.pauseVideoCb = pauseVideoCb
			this.indexOfPlayingVideo = slideIndex
		},
		
		//播放Live视频
		LivePlay(img_item) {
			if(img_item.LivePlayState){ return }
			this.swiper.autoplay.stop();
			this.$set(img_item, 'LivePlayState', true);
		   const videoElement = this.liveVideo;
		   if (videoElement) {
				this.$set(img_item, 'LivePlayState', false);
				this.$set(videoElement, 'muted', true); // 静音
				this.$set(videoElement, 'controls', true); // 隐藏控件
		      videoElement.play();  // 播放视频
				
		      // videoElement.muted = true;  // 静音
		      // videoElement.controls = false;  // 隐藏控件
		      // videoElement.play();  // 播放视频
		   }
		},
		
		//Live视频播放完显示回图片
		stopLivePlay(img_item) {
			this.$set(img_item, 'LivePlayState', false);
			this.swiper.autoplay.start();
		   const videoElement = this.liveVideo;
		   if (videoElement) {
				this.$set(img_item, 'LivePlayState', false);
				this.$set(videoElement, 'currentTime', 0);
		      videoElement.pause();  // 播放视频
			
				// this.$set(img_item, 'LivePlayState', false);
				// this.$nextTick(() => {
				//    const videoElement = this.liveVideo;
				//    if (videoElement) {
				// 		videoElement.pause();  // 停止播放
				//       videoElement.currentTime = 0;  // 重置到视频开头
				//    }
				// });
		   }
		},
	  
		//鼠标移入暂停轮播
		stopAutoplay() {
		   console.log('Stopping autoplay for:', this.swiper);
			if (this.swiper) {
				console.log('Stopping autoplay for:', this.swiper);
				this.swiper.autoplay.stop();
			} else {
				console.warn('No swiper available to stop.');
			}
		},
		
		//鼠标移出开始轮播
		startAutoplay() {
		   console.log('Stopping autoplay for:', this.swiper);
			if (this.swiper) {
				console.log('Starting autoplay for:', this.swiper);
				this.swiper.autoplay.start();
			} else {
				console.warn('No swiperInstance available to start.');
			}
		},

	},
};
</script>

<style lang="less" scoped>
	 @import '~swiper/css/swiper.css';
	.picture_and_video_box {
	  margin-top: 15px;
	}

	.media-carousel {
	  width: 100%;
	  margin: 0 auto;
	}

	.media-image {
	  width: 100%;
	  height: auto;
	  object-fit: cover;
	  border-radius: 5px;
	}

	.Live-video{
	  width: 100%;
	  height: 100%;
	  border-radius: 5px;
	}
	.media-video {
	  width: 100%;
	  height: auto;
	  border-radius: 5px;
	}

	.swiper {
	  width: 100%;
	  height: auto;
	}

	.swiper-slide {
	  display: flex;
	  justify-content: center;
	  align-items: center;
	}

	/deep/ .swiper-pagination-bullet {
		width: 20px;
		height: 8px;
		display: inline-block;
		border-radius: 4px;
		background: #000;
		border: 1px #fff solid;
		opacity: 0.5;
		margin: 0px 4px;
	}
	.swiper-pagination {
	  position: absolute;
	  bottom: 10px;  /* Adjust to position the pagination at the bottom */
	  left: 50%;
	  transform: translateX(-50%);
	  z-index: 10;
	}
	/deep/ .swiper-pagination-bullet-active {
	   opacity: 1;
		background: #06f;
		// background: #2094FA;
	}
	.media-carousel .swiper-slide{
		max-height: 100%;
	}
	.swiperBox{
		position: relative;
	}
	.quantityBox{
		position: absolute;
		top: 10px;
		right: 10px;
		z-index: 999;
		padding: 5px 10px;
		line-height: 1;
		background-color: rgba(0, 0, 0, 0.5);
		border: 1px #f5f5f5 solid;
		color: #ffffff;
		font-size: 12px;
		border-radius: 4px;
		display: flex;
	}
	.slideLiveBox{
		position: relative;
		video::-webkit-media-controls {
		    display: none!important;
		}
		video::-webkit-media-controls-enclosure {
		    display: none!important;
		}
		video::-webkit-media-controls-panel {
		    display: none!important;
		}
		
		video::-moz-media-controls {
		    display: none!important;
		}
		video::-moz-media-controls-enclosure {
		    display: none!important;
		}
		video::-moz-media-controls-panel {
		    display: none!important;
		}
		
		video::-ms-media-controls {
		    display: none!important;
		}
		video::-ms-media-controls-enclosure {
		    display: none!important;
		}
		video::-ms-media-controls-panel {
		    display: none!important;
		}
		
		video::media-controls {
		    display: none!important;
		}
		video::media-controls-enclosure {
		    display: none!important;
		}
		video::media-controls-panel {
		    display: none!important;
		}
	}
	.LiveBtn{
		position: absolute;
		top: 10px;
		left: 10px;
		z-index: 999;
		padding: 5px 10px;
		line-height: 1;
		background-color: rgba(0, 0, 0, 0.5);
		border: 1px #f5f5f5 solid;
		color: #ffffff;
		font-size: 14px;
		border-radius: 4px;
	}
	.LiveBtn.noBtn{
		background-color: #666666;
		color: #999999;
		border: 1px #666666 solid;
	}
	.pointer{
		cursor: pointer;
	}
	.no-drop{
		cursor: no-drop;
	}
</style>
